function isFixedElementOffscreen(element) {
    if (!isHTMLElement(element)) { return false }
    const { position } = getComputedStyle(element);

    if (position === 'fixed') {
        const rect = element.getBoundingClientRect();
        return rect.right <= 0;
    }

    return false;
}

function isElementHidden(element) {
    if (!isHTMLElement(element)) { return false }
    const styles = window.getComputedStyle(element);
    return styles.display === 'none';
}

function isElementInvisible(element) {
    if (!isHTMLElement(element)) { return false }
    const styles = window.getComputedStyle(element);
    return styles.visibility === 'hidden';
}

function isHTMLElement(obj) {
    return obj instanceof HTMLElement;
}

export default function isElementOnScreen(element) {
    if (isElementInvisible(element)) return false
    if (isElementHidden(element)) return false
    if (isFixedElementOffscreen(element)) return false
    return true
}